import { IUseGa, ISendDataLayer } from './interface.d'

declare global {
  interface Window {
    dataLayer: {
      push: (data: unknown) => void
    }
  }
}

const useGa: IUseGa = () => {
  const { dataLayer } = window

  const sendDataLayer = (data: ISendDataLayer) => {
    dataLayer.push(data)
  }

  return { sendDataLayer }
}

export default useGa
